import gql from 'graphql-tag'

export const GET_SCHOOL_DETAILS = gql`
  query {
    schoolDetail {
      id
      schoolName
      contactNo
      email
      address
      gst
      country {
        id
        name
      }
      currency {
        id
        currency
        symbol
      }
      logo
      bankName
      bankAccountNo
      ifscCode
      accountHolderName
      paymentLink
      upi
      gpay
      paytm
    }
  }
`

export const GET_CLINIC_RATES = gql`
  query($clinic: ID!) {
    getStudentInvoiceFee(isClinic: true, clinic: $clinic) {
      edges {
        node {
          id
          isClinic
          feeType
          gstApplicable
          student {
            id
            firstname
          }
          flatItems {
            edges {
              node {
                id
                flatRate
                item {
                  id
                  name
                }
              }
            }
          }
          hourlyItems {
            edges {
              node {
                id
                hour
                hourRate
                item {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`
export const GET_INVOICES = gql`
  query getInvoices($from: Date, $to: Date, $status: ID, $customer_School: ID) {
    getInvoices(
      date_Gte: $from
      date_Lte: $to
      status: $status
      customer_School: $customer_School
    ) {
      edges {
        node {
          id
          invoiceNo
          email
          issueDate
          dueDate
          amount
          address
          taxableSubtotal
          discount
          total
          linkGenerated
          paymentLink
          currency {
            id
            currency
            symbol
          }
          customer {
            id
            firstname
            lastname
          }
          clinic {
            id
            schoolName
            currency {
              id
              currency
              symbol
            }
          }
          status {
            id
            statusName
            colorCode
          }
          invoiceFee {
            edges {
              node {
                id
                quantity
                rate
                amount
                tax
                schoolServices {
                  id
                  name
                  description
                }
              }
            }
          }
        }
      }
    }
  }
`
export const GET_ALL_INVOICE = gql`
  query getInvoices($from: Date, $to: Date, $status: ID) {
    getInvoices(date_Gte: $from, date_Lte: $to, status: $status) {
      edges {
        node {
          id
          invoiceNo
          email
          issueDate
          dueDate
          amount
          address
          taxableSubtotal
          discount
          total
          linkGenerated
          paymentLink
          currency {
            id
            currency
            symbol
          }
          customer {
            id
            firstname
            lastname
          }
          clinic {
            id
            schoolName
            currency {
              id
              currency
              symbol
            }
          }
          status {
            id
            statusName
            colorCode
          }
          invoiceFee {
            edges {
              node {
                id
                quantity
                rate
                amount
                tax
                schoolServices {
                  id
                  name
                  description
                }
              }
            }
          }
        }
      }
    }
  }
`

export const CREATE_STUDENT_INVOICE = gql`
  mutation(
    $student: ID!
    # $month: String!
    $startDate: String!
    $endDate: String!
    $cgst: Float
    $sgst: Float
    $discount: Float
    $discountAmount: Float
    $tax: Float
    $hsnSacCode: String
    $invoiceType: String
  ) {
    generateMonthlyStudentInvoice(
      input: {
        student: $student
        startDate: $startDate
        endDate: $endDate
        cgst: $cgst
        sgst: $sgst
        discount: $discount
        discountAmount: $discountAmount
        tax: $tax
        hsnSacCode: $hsnSacCode
        invoiceType: $invoiceType
      }
    ) {
      details {
        id
        invoiceNo
        email
      }
      data
    }
  }
`

export const UPDATE_STUDENT_INVOICE = gql`
  mutation(
    $pk: ID
    $email: String
    $status: ID
    $issueDate: Date
    $dueDate: Date
    $address: String
    $amount: Float
    $taxableSubtotal: Float
    $discount: Float
    $discountAmount: Float
    $sgst: Float
    $cgst: Float
    $tax: Float
    $total: Float
    $products: [FeeInput2]
  ) {
    updateInvoice(
      input: {
        pk: $pk
        email: $email
        status: $status
        issueDate: $issueDate
        dueDate: $dueDate
        amount: $amount
        address: $address
        taxableSubtotal: $taxableSubtotal
        discount: $discount
        discountAmount: $discountAmount
        sgst: $sgst
        cgst: $cgst
        tax: $tax
        total: $total
        products: $products
      }
    ) {
      details {
        id
        linkGenerated
        status {
          id
          statusName
        }
      }
    }
  }
`

export const DELETE_INVOICE = gql`
  mutation deleteInvoice($id: ID!) {
    deleteInvoice(input: { pk: $id }) {
      status
      message
    }
  }
`

export const STUDENTS = gql`
  query {
    students(isActive: true) {
      edges {
        node {
          id
          firstname
          lastname
          parent {
            id
          }
          invoiceSet {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`

export const STUDENT_INVOICE_ITEMS = gql`
  query {
    getStudentInvoiceItems {
      id
      name
    }
  }
`

export const PRODUCT_LIST = gql`
  query {
    invoiceProductsList {
      id
      name
      description
    }
  }
`

export const CREATE_STUDENT_INVOICE_ITEM = gql`
  mutation($name: String!) {
    createStudentInvoiceItem(input: { name: $name }) {
      details {
        id
        name
        school {
          id
          schoolName
        }
      }
    }
  }
`

export const GET_STUDENT_INVOICE_FEE = gql`
  query($student: ID) {
    getStudentInvoiceFee(student: $student) {
      edges {
        node {
          id
          feeType
          startDate
          endDate
          gstApplicable
          student {
            id
            firstname
          }
          flatItems {
            edges {
              node {
                id
                flatRate
                item {
                  id
                  name
                }
              }
            }
          }
          hourlyItems {
            edges {
              node {
                id
                hour
                hourRate
                item {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_STUDENT_FEE_DETAILS = gql`
  query {
    getStudentInvoiceFeeDetails(id: "U3R1ZGVudEludm9pY2VmZWVUeXBlOjE=") {
      id
      feeType
      startDate
      endDate
      gstApplicable
      student {
        id
        firstname
      }
      flatItems {
        edges {
          node {
            id
            flatRate
            item {
              id
              name
            }
          }
        }
      }
      hourlyItems {
        edges {
          node {
            id
            hour
            hourRate
            item {
              id
              name
            }
          }
        }
      }
    }
  }
`

export const CREATE_STUDENT_RATES = gql`
  mutation(
    $student: ID!
    $feeType: String!
    $startDate: Date
    $endDate: Date
    $gstApplicable: Boolean
    $flatItems: [FlatItemsInput]
    $hourlyItems: [HourlyItemsInput]
    $isClinic: Boolean
  ) {
    createStudentRates(
      input: {
        student: $student
        feeType: $feeType
        startDate: $startDate
        endDate: $endDate
        gstApplicable: $gstApplicable
        hourlyItems: $hourlyItems
        flatItems: $flatItems
        isClinic: $isClinic
      }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`
export const CREATE_CLINIC_RATES = gql`
  mutation(
    $clinic: ID
    $feeType: String!
    $startDate: Date
    $endDate: Date
    $isClinic: Boolean
    $gstApplicable: Boolean
    $flatItems: [FlatItemsInput]
    $hourlyItems: [HourlyItemsInput]
  ) {
    createStudentRates(
      input: {
        clinic: $clinic
        feeType: $feeType
        startDate: $startDate
        endDate: $endDate
        isClinic: $isClinic
        gstApplicable: $gstApplicable
        hourlyItems: $hourlyItems
        flatItems: $flatItems
      }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        clinic {
          id
          schoolName
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const GENERATE_LINK = gql`
  mutation($pk: [ID]!) {
    razorpayGenerateLink(input: { pk: $pk }) {
      status
      message
    }
  }
`

export const PAYMENT_REMINDER = gql`
  mutation($pk: [ID]!) {
    razorpayInvoiceNotification(input: { pk: $pk }) {
      status
      message
    }
  }
`
export const GET_PAYMENT_RECIEVING_DETIAILS = gql`
  query {
    schoolDetail {
      id
      schoolName
      bankName
      bankAccountNo
      ifscCode
      accountHolderName
    }
  }
`

export const GET_INVOICE = gql`
  query($id: ID!) {
    invoiceDetail(id: $id) {
      id
      invoiceNo
      email
      issueDate
      dueDate
      amount
      address
      taxableSubtotal
      discount
      discountAmount
      sgst
      cgst
      tax
      total
      linkGenerated
      paymentLink
      lastAmount
      hoursUsed
      currency {
        id
        currency
        symbol
      }
      clinic {
        id
        schoolName
        address
      }
      customer {
        id
        firstname
        lastname
        school {
          id
          schoolName
          email
          address
          logo
        }
      }
      status {
        id
        statusName
      }
      invoiceFee {
        edges {
          node {
            id
            quantity
            rate
            amount
            tax
            hsnSac
            schoolServices {
              id
              name
              description
            }
          }
        }
      }
    }
  }
`
export const UPDATE_CLINIC_RATES = gql`
  mutation(
    $pk: ID!
    $feeType: String
    $isClinic: Boolean
    $gstApplicable: Boolean
    $flatItems: [FlatItemsInput]
    $hourlyItems: [HourlyItemsInput]
  ) {
    updateStudentRates(
      input: {
        pk: $pk
        feeType: $feeType
        isClinic: $isClinic
        gstApplicable: $gstApplicable
        flatItems: $flatItems
        hourlyItems: $hourlyItems
      }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
        hourlyItems {
          edges {
            node {
              id
              hour
              hourRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const UPDATE_STUDENT_FLAT_RATES = gql`
  mutation($pk: ID!, $flatItems: [FlatItemsInput], $hourlyItems: [HourlyItemsInput]) {
    updateStudentRates(
      input: { pk: $pk, flatItems: $flatItems, hourlyItems: $hourlyItems, isClinic: false }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
        hourlyItems {
          edges {
            node {
              id
              hour
              hourRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const UPDATE_CLINIC_FLAT_RATES = gql`
  mutation(
    $pk: ID!
    $flatRate: Int
    $fPk: ID
    $item: ID
    $isClinic: Boolean
    $clinic: ID
    $feeType: String
  ) {
    updateStudentRates(
      input: {
        pk: $pk
        flatItems: [{ flatRate: $flatRate, item: $item, pk: $fPk }]
        isClinic: $isClinic
        clinic: $clinic
        feeType: $feeType
      }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const UPDATE_CLINIC_HOURLY_RATES = gql`
  mutation(
    $pk: ID!
    $hourRate: Int
    $hour: Int
    $fPk: ID
    $item: ID
    $isClinic: Boolean
    $clinic: ID
    $feeType: String
  ) {
    updateStudentRates(
      input: {
        pk: $pk
        hourlyItems: [{ hourRate: $hourRate, hour: $hour, item: $item, pk: $fPk }]
        isClinic: $isClinic
        clinic: $clinic
        feeType: $feeType
      }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const UPDATE_STUDENT_RATES = gql`
  mutation(
    $pk: ID!
    $isClinic: Boolean
    $flatItems: [FlatItemsInput]
    $hourlyItems: [HourlyItemsInput]
  ) {
    updateStudentRates(
      input: { pk: $pk, isClinic: $isClinic, flatItems: $flatItems, hourlyItems: $hourlyItems }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
        hourlyItems {
          edges {
            node {
              id
              hour
              hourRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const REMOVE_FEE_ITEM = gql`
  mutation($pk: ID!, $removeFlatItems: [ID], $removeHourlyItems: [ID]) {
    updateStudentRates(
      input: { pk: $pk, removeFlatItems: $removeFlatItems, removeHourlyItems: $removeHourlyItems }
    ) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
        hourlyItems {
          edges {
            node {
              id
              hour
              hourRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const REMOVE_FEE_ITEM_2 = gql`
  mutation($pk: ID!, $removeFlatItems: [ID]) {
    updateStudentRates(input: { pk: $pk, removeFlatItems: $removeFlatItems }) {
      details {
        id
        feeType
        startDate
        endDate
        gstApplicable
        student {
          id
          firstname
        }
        flatItems {
          edges {
            node {
              id
              flatRate
              item {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

export const GET_PAYMENT_METHODS = gql`
  query {
    getPaymentMethods {
      id
      method
    }
  }
`

export const GET_INVOICE_STATUS_LIST = gql`
  query {
    invoiceStatusList {
      id
      statusName
      colorCode
    }
  }
`

export const GET_INVOICE_PAYMENTS = gql`
  query($invoice: ID) {
    getInvoicePayments(invoice: $invoice) {
      edges {
        node {
          id
          amount
          datetime
          paymentMethod {
            id
            method
          }
          createdBy {
            id
            username
          }
          invoice {
            id
            invoiceNo
          }
        }
      }
    }
  }
`

export const CREATE_INVOICE_PAYMENT = gql`
  mutation($invoiceId: ID!, $paymentMethod: ID!, $amount: Float!) {
    createInvoicePayments(
      input: { invoiceId: $invoiceId, paymentMethod: $paymentMethod, amount: $amount }
    ) {
      details {
        id
        amount
        datetime
        paymentMethod {
          id
          method
        }
        createdBy {
          id
          username
        }
        invoice {
          id
          invoiceNo
        }
      }
    }
  }
`

export const UPDATE_INVOICE_STATUS = gql`
  mutation($pk: ID, $status: ID) {
    updateInvoice(input: { pk: $pk, status: $status }) {
      details {
        id
        status {
          id
          statusName
        }
      }
    }
  }
`

export const UPDATE_INVOICE_PAYMENT = gql`
  mutation {
    updateInvoicePayments(
      input: {
        pk: "SW52b2ljZVBheW1lbnRUeXBlOjE="
        invoiceId: "SW52b2ljZVR5cGU6NDQ="
        paymentMethod: "UGF5bWVudE1ldGhvZHNUeXBlOjI="
        amount: 99.0
      }
    ) {
      details {
        id
        amount
        datetime
        paymentMethod {
          id
          method
        }
        createdBy {
          id
          username
        }
        invoice {
          id
          invoiceNo
        }
      }
    }
  }
`

export const DELETE_INVOICE_PAYMENTS = gql`
  mutation {
    deleteInvoicePayments(input: { pk: "SW52b2ljZVBheW1lbnRUeXBlOjE=" }) {
      status
      message
    }
  }
`

export const DELETE_ALL_INVOICE_PAYMENTS = gql`
  mutation {
    deleteAllInvoicePayments(input: { invoiceId: "" }) {
      status
      message
    }
  }
`

export const STUDENT_INFO = gql`
  query student($student: ID!) {
    student(id: $student) {
      firstname
      lastname
    }
  }
`

export const SCHOOL_CURRENCY = gql`
  query($id: ID!) {
    school(id: $id) {
      id
      schoolName
      paytm
      gpay
      upi
      gst
      bankAccountNo
      bankName
      ifscCode
      accountHolderName
      billingName
      paymentLink
      currency {
        id
        currency
        symbol
      }
    }
  }
`

export const UPDATE_CLINIC = gql`
  mutation($upi: String, $paytm: String, $gpay: String, $paymentLink: String) {
    updateClinic(input: { upi: $upi, paytm: $paytm, gpay: $gpay, paymentLink: $paymentLink }) {
      school {
        id
        upi
        gpay
        paytm
        schoolName
        billingName
        currency {
          id
          currency
          symbol
        }
      }
    }
  }
`

export const UPDATE_CLINIC_BANK_DETAILS = gql`
  mutation(
    $bankName: String
    $bankAccountNo: String
    $ifscCode: String
    $accountHolderName: String
    $gst: String
  ) {
    updateClinic(
      input: {
        bankName: $bankName
        bankAccountNo: $bankAccountNo
        ifscCode: $ifscCode
        accountHolderName: $accountHolderName
        gst: $gst
      }
    ) {
      school {
        id
        schoolName
        bankName
        bankAccountNo
        ifscCode
        accountHolderName
        billingName
        gst
      }
    }
  }
`
export const UPDATE_CLINIC_CURRENCY = gql`
  mutation($billingName: String, $currency: ID) {
    updateClinic(input: { billingName: $billingName, currency: $currency }) {
      school {
        id
        schoolName
        bankName
        bankAccountNo
        ifscCode
        accountHolderName
        billingName
        currency {
          id
          currency
          symbol
        }
      }
    }
  }
`

export const CURRENCY = gql`
  query {
    currency {
      id
      currency
      symbol
    }
  }
`
export const SEND_EMAIL_INVOICE = gql`
  mutation($invoiceId: ID!, $attachment: String!) {
    sendStudentInvoices(input: { invoices: [{ pk: $invoiceId, attachment: $attachment }] }) {
      status
      message
    }
  }
`
